import { useLanguage } from "assets/languages";
import BRAND from "constants/brand";
import { LOCALES } from "constants/locales";

export const delay = (ms:number) => new Promise((resolve) => setTimeout(() => { resolve(true) }, ms))

export const getCookie = (name: string) => {
  const cookieValue = document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${name}=`));
  return cookieValue ? cookieValue.split('=')[1] : undefined;
};

export const sanitizeFileName = (name: string): string => {
  // WINDOWS - \ / : * ? " < > | 
  // MAC - / : * ? " < > | 
  // UNIX - / : * ? " < > | 
  // LINUX - / : * ? " < > | 
  return name
    .replace(/\\|\/|\:|\*|\?|\"|\<|\>|\||[\x00-\x1F]|\x7F/g, '_')
};